var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brands"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card",
    width: 32,
    height: 24,
    rx: 4,
    fill: "#007BFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa",
    d: "M16.4122 10.7275C16.3985 11.8071 17.3743 12.4096 18.1094 12.7678C18.8647 13.1353 19.1184 13.371 19.1155 13.6996C19.1097 14.2026 18.513 14.4246 17.9545 14.4332C16.9801 14.4484 16.4137 14.1702 15.9632 13.9598L15.6123 15.6022C16.0641 15.8105 16.9008 15.9921 17.7685 16C19.8052 16 21.1377 14.9947 21.1449 13.4358C21.1528 11.4576 18.4085 11.348 18.4272 10.4638C18.4337 10.1957 18.6896 9.90955 19.2503 9.83677C19.5277 9.80001 20.2938 9.77191 21.1622 10.1719L21.5031 8.58279C21.0361 8.41271 20.4358 8.24984 19.6884 8.24984C17.7714 8.24984 16.423 9.26887 16.4122 10.7275ZM24.7786 8.38676C24.4067 8.38676 24.0932 8.60369 23.9534 8.93664L21.044 15.8833H23.0792L23.4842 14.764H25.9713L26.2062 15.8833H28L26.4347 8.38676H24.7786ZM25.0632 10.4119L25.6506 13.2268H24.042L25.0632 10.4119ZM13.9446 8.38676L12.3404 15.8833H14.2797L15.8833 8.38676H13.9446ZM11.0756 8.38676L9.05699 13.4892L8.24047 9.15068C8.14462 8.66639 7.76626 8.38676 7.34611 8.38676H4.04612L4 8.60441C4.67744 8.75143 5.44712 8.98853 5.9134 9.24221C6.19879 9.39715 6.28022 9.53264 6.37391 9.90091L7.92049 15.8833H9.97009L13.1122 8.38676H11.0756Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.8a9affb5f16682e9980e7aca139d0449.svg";
export { ForwardRef as ReactComponent };